import { MouseEvent, useState } from 'react';
import { useParams } from 'react-router-dom';
import { LoadingSpinner } from '@medtronic/pecc-react-component-library-js';
import { Box, Stack, Typography } from '@mui/material';
import { useGetETLJobsHistoryQuery, useGetEmrsQuery, useGetScheduledETLJobsQuery } from '~/api/v2/hooks';
import { createBlockContainerStyles } from '../StudioIntegrationTab/components/styles';
import { ETLJobsTableToggle, EmptyScheduledJobs, JobHistoryTab, ScheduledJobsTab } from './components';
import { ETLJobsTablesEnum } from './types';

const ETLJobsTab = () => {
  const projectId = +useParams().projectid!;
  const { data: scheduledJobs } = useGetScheduledETLJobsQuery({ projectId });
  const { data: jobHistory } = useGetETLJobsHistoryQuery({ projectId });
  const { data: emrs } = useGetEmrsQuery({ projectId });

  const [selectedTable, setSelectedTable] = useState<ETLJobsTablesEnum>(ETLJobsTablesEnum.SCHEDULED_JOBS);

  const handleToggleButtonGroupChange = (_: MouseEvent<HTMLElement>, newSelectedTable: ETLJobsTablesEnum | null) => {
    if (newSelectedTable) setSelectedTable(newSelectedTable);
  };

  const selectedTableConfig = {
    [ETLJobsTablesEnum.SCHEDULED_JOBS]: ScheduledJobsTab,
    [ETLJobsTablesEnum.JOB_HISTORY]: JobHistoryTab,
  };

  const SelectedTableComponent = selectedTableConfig[selectedTable];

  const etlJobsExist = (scheduledJobs?.data.length || jobHistory?.data.length) && emrs;

  if (scheduledJobs?.pagination.total === undefined || jobHistory?.pagination.total === undefined) {
    return (
      <Box display="flex" justifyContent="center" my="15vh">
        <LoadingSpinner />
      </Box>
    );
  }

  return (
    <Box minHeight="50vh">
      <Box p={4} gap={4} display="flex" flexDirection="column">
        <Stack direction="row" spacing={2} alignItems="center">
          <Typography variant="h5">ETL Jobs</Typography>
          {!!etlJobsExist && (
            <ETLJobsTableToggle
              selectedTable={selectedTable}
              onToggleButtonGroupChange={handleToggleButtonGroupChange}
            />
          )}
        </Stack>
        {etlJobsExist ? (
          <Box sx={createBlockContainerStyles}>
            <SelectedTableComponent />
          </Box>
        ) : (
          <EmptyScheduledJobs />
        )}
      </Box>
    </Box>
  );
};

export default ETLJobsTab;
